import { TicketOfficeView } from '../../../types/ticket-office';
import { EventDetail, EventDetailsProps } from '../../components/EventDetails';

export const getEventDetails = (view: TicketOfficeView): EventDetailsProps => {
    const { state } = view;
    const { lang, event } = state;

    const items: EventDetail[] = [
        {
            icon: 'calendar',
            iconTitle: lang.eventDetails.date,
            text: event.time,
        },
        {
            icon: 'location',
            iconTitle: lang.eventDetails.location,
            text: event.roomName,
        },
    ];

    if (event.duration) {
        items.push({
            icon: 'clock',
            iconTitle: lang.eventDetails.duration,
            text: event.duration,
        });
    }

    if (event.languages) {
        items.push({
            icon: 'globe',
            iconTitle: lang.eventDetails.language,
            text: event.languages,
        });
    }

    if (event.subtitles) {
        items.push({
            icon: 'subtitle',
            iconTitle: lang.eventDetails.subtitles,
            text: event.subtitles,
        });
    }

    if (event.ageLimit) {
        items.push({
            icon: 'security',
            iconTitle: lang.eventDetails.ageLimit,
            text: event.ageLimit,
        });
    }

    const eventDetails: EventDetailsProps = {
        publicInfo: event.publicInfo,
        items,
    };

    eventDetails.tags = state.event.tags;

    return eventDetails;
};
